import { Alert, Button, Stack, Typography } from "@mui/material";

import React from "react";
import { useTranslation } from "react-i18next";

export type SignedFlowErrorAlertProps = {
  uploadError: boolean;
  onRestart: () => void;
};

/**
 * Error info for signed flow (e.g. upload error). Use alongside SignedFlowTimerAlert for timer/timeout.
 */
export const SignedFlowErrorAlert: React.FC<SignedFlowErrorAlertProps> = ({
  uploadError,
  onRestart,
}) => {
  const { t } = useTranslation();

  if (!uploadError) return null;

  return (
    <Alert severity="error">
      <Stack spacing={1.5}>
        <Typography variant="subtitle2" component="p" fontWeight="bold">
          {t("signedFlow.uploadErrorTitle")}
        </Typography>
        <Typography variant="body2" component="p">
          {t("signedFlow.uploadErrorMessage")}
        </Typography>
        <Stack direction="row" justifyContent="flex-end">
          <Button
            variant="contained"
            color="error"
            size="small"
            onClick={onRestart}
            sx={{ whiteSpace: "nowrap" }}
          >
            {t("signedFlow.restartShort")}
          </Button>
        </Stack>
      </Stack>
    </Alert>
  );
};
